import moment from 'moment-timezone';

export const DELETE_TEMP_ABSENCE = 'DELETE_TEMP_ABSENCE';
export const DELETE_TEMP_ABSENCE_SHOW = `${DELETE_TEMP_ABSENCE}_SHOW`;

export const DELETE_TEMP_ABSENCE_START = `${DELETE_TEMP_ABSENCE}_START`;
export const DELETE_TEMP_ABSENCE_SUCCESS = `${DELETE_TEMP_ABSENCE}_SUCCESS`;
export const DELETE_TEMP_ABSENCE_FAIL = `${DELETE_TEMP_ABSENCE}_FAIL`;

export const LOAD_INITIAL_TEMP_ABSENCE_LIST = 'LOAD_INITIAL_TEMP_ABSENCE_LIST';
export const LOAD_INITIAL_TEMP_ABSENCE_LIST_START = `${LOAD_INITIAL_TEMP_ABSENCE_LIST}_START`;
export const LOAD_INITIAL_TEMP_ABSENCE_LIST_SUCCESS = `${LOAD_INITIAL_TEMP_ABSENCE_LIST}_SUCCESS`;
export const LOAD_INITIAL_TEMP_ABSENCE_LIST_FAIL = `${LOAD_INITIAL_TEMP_ABSENCE_LIST}_FAIL`;

export const LOAD_TEMP_ABSENCE_LIST = 'LOAD_TEMP_ABSENCE_LIST';
export const LOAD_TEMP_ABSENCE_LIST_START = `${LOAD_TEMP_ABSENCE_LIST}_START`;
export const LOAD_TEMP_ABSENCE_LIST_SUCCESS = `${LOAD_TEMP_ABSENCE_LIST}_SUCCESS`;
export const LOAD_TEMP_ABSENCE_LIST_FAIL = `${LOAD_TEMP_ABSENCE_LIST}_FAIL`;

export const TEMP_ABSENCE_LIST_SHOW = 'TEMP_ABSENCE_LIST_SHOW';

export const showDeletionPrompt = (open = true) => ({
  type: DELETE_TEMP_ABSENCE_SHOW,
  payload: {
    open,
  },
});

export const showTemporaryAbsenceList = (open = true) => ({
  type: TEMP_ABSENCE_LIST_SHOW,
  payload: {
    open,
  },
});

export const deleteAbsenceById = id => ({
  type: DELETE_TEMP_ABSENCE,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/temporary-absences/${id}`,
    method: 'del',
  },
});

export const getAbsencesByUserId = userId => {
  const apiPath = '/webapi/xm/1/temporary-absences';
  const params = {
    from: moment.utc().format(),
    member: userId,
    embed: 'group,replacement',
  };

  return {
    type: LOAD_INITIAL_TEMP_ABSENCE_LIST,
    meta: {
      xmApi: true,
      uri: apiPath,
      method: 'get',
      params,
    },
  };
};

export const getAbsencesByUserIdAndBetween = ({
  startIndex,
  stopIndex,
  userId,
}) => {
  const apiPath = '/webapi/xm/1/temporary-absences';
  const limit = Math.max(1, stopIndex - startIndex);
  const params = {
    offset: startIndex,
    from: moment.utc().format(),
    embed: 'group,replacement',
    limit,
    member: userId,
  };

  return {
    type: LOAD_TEMP_ABSENCE_LIST,
    meta: {
      xmApi: true,
      uri: apiPath,
      method: 'get',
      params,
    },
  };
};
